import React from 'react'
function Input(props) {
  const {
    input,
    submit,
    getLastUrlRef,
    getInputRef,
    changeInputValue,
    handleInput,
    inputValue,
    inputOnFocus,
    inputOnBlur,
    turnIntoBlur,
    inputOnCompositionEnd,
    inputOnCompositionStart,
    loadingStyle,
    inputButtonStyle
  } = props
  return (<div className="container grid-md pt-2" key={2}>
    <div className="columns col-gapless">
      <div className="column col-10 has-icon-right">
        <div className="input-group">
          <span className="input-group-addon">
            <a target="_blank" ref={getLastUrlRef}
              className="text-dark" tabIndex="-1" onFocus={turnIntoBlur}>{input}</a>
          </span>
          <input type="text" className="form-input" placeholder="" ref={getInputRef}
            tabIndex="-1" onChange={changeInputValue} value={inputValue}
          onFocus={inputOnFocus} onBlur={inputOnBlur} onCompositionStart={inputOnCompositionStart}
        onCompositionEnd={inputOnCompositionEnd}/>
        </div>
        <i className="form-icon loading" style={loadingStyle}></i>
      </div>
      <div className="column col-2">
        <button className={"btn-block"+" "+inputButtonStyle} tabIndex="-1"
          onClick={handleInput} onFocus={turnIntoBlur}>{submit}</button>
      </div>
    </div>
  </div>)
}

export default Input



// WEBPACK FOOTER //
// ./src/textModule/Input.js